// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"avatar_wrapper__3W9bI","large":"avatar_large__f56Fx","medium":"avatar_medium__Jmvn2","small":"avatar_small__j7fa2","imgHidden":"avatar_imgHidden__1FJA2"};